import { Model, type ModelProps } from '@/infra/model'
import { observable } from 'mobx'
import { type Id } from '@/infra/id'

/**
 * User type.
 */
export type UserType = 'USER' | 'PRO' | 'ADMIN'

/**
 * Props for {@link UserData}.
 */
export type UserDataProps = ModelProps<UserData>

/**
 * User data.
 */
export class UserData extends Model<UserData> {
  /**
   * ID of the backing user.
   */
  @observable accessor id: Id

  /**
   * Slugs of the workspaces that the user is a member of.
   */
  @observable accessor workspaceSlugs: string[] = []

  /**
   * User type.
   */
  @observable accessor type: UserType = 'USER'
}
